/*
 * Animates the product page collapsible rows (.product-collapsible) open/closed.
 * Uses the native <details> element for accessibility / no-JS fallback, and
 * animates the content height with a max-height transition (mirrors the
 * accordion section). Event delegation keeps it working after section re-renders.
 */
(function () {
  if (window.__bbCollapsibleInit) return;
  window.__bbCollapsibleInit = true;

  function clearPending(content) {
    if (content._bbDone) {
      content.removeEventListener('transitionend', content._bbDone);
      content._bbDone = null;
    }
  }

  function openRow(details, content) {
    clearPending(content);
    details.open = true;
    content.style.maxHeight = '0px';
    // force reflow so the browser registers the start value
    content.offsetHeight;
    content.style.maxHeight = content.scrollHeight + 'px';

    content._bbDone = function (event) {
      if (event.propertyName !== 'max-height') return;
      content.style.maxHeight = 'none';
      clearPending(content);
    };
    content.addEventListener('transitionend', content._bbDone);
  }

  function closeRow(details, content) {
    clearPending(content);
    content.style.maxHeight = content.scrollHeight + 'px';
    content.offsetHeight;
    content.style.maxHeight = '0px';

    content._bbDone = function (event) {
      if (event.propertyName !== 'max-height') return;
      details.open = false;
      content.style.maxHeight = '';
      clearPending(content);
    };
    content.addEventListener('transitionend', content._bbDone);
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.product-collapsible > details > summary');
    if (!summary) return;

    var details = summary.parentElement;
    var content = details.querySelector('.product-collapsible__content');
    if (!content) return;

    // Take over the native toggle so we can animate it.
    event.preventDefault();

    if (details.open) {
      closeRow(details, content);
    } else {
      openRow(details, content);
    }
  });
})();
